var render, staticRenderFns
import script from "./LotsIMadeBid.vue?vue&type=script&lang=js&"
export * from "./LotsIMadeBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273b8bf",
  null
  
)

export default component.exports